import { Fraction } from 'bi-fraction';
import { getBestAMMTradeOpts } from '../utils/getBestAMMTradeOpts';
import { getTradeExtraInfo } from '../utils/getTradeExtraInfo';
export class SmartRouterServiceAbstract {
    constructor() {
        this.getSwapInfo = async (from, to, userConfig = {}) => {
            const wrappedFrom = this.toWrappedToken(from);
            const wrappedFromAmount = new Fraction(from.amount)
                .shr(from.decimals)
                .shl(wrappedFrom.decimals)
                .toFixed(0);
            const opts = getBestAMMTradeOpts(from, to, userConfig);
            const args = await this.getBestAMMTrade({
                ...opts,
                from: wrappedFrom,
                amount: wrappedFromAmount,
                to: this.toWrappedToken(to),
            });
            if (!args)
                return;
            const info = getTradeExtraInfo(args, opts.slippageTolerance);
            return {
                opts,
                args,
                info,
            };
        };
    }
}
